module.exports = __webpack_public_path__ + "static/docsFrontDesktop-62a1b58fb94af40bec583423a2979913.png";